import { render, staticRenderFns } from "./selectbox-question.vue?vue&type=template&id=5754d9d6"
import script from "./selectbox-question.vue?vue&type=script&lang=js"
export * from "./selectbox-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports